import React, { Suspense } from 'react';
// import ProductCard from './ProductCard.js';

const LoadableBuyCard = React.lazy(() => import(/* webpackChunkName: "buyCardComponent" */ '@/features/product/product-card/components/ProductCard'));

function ProductGrouping(props) {
	let cards = props.cards;
	let no_Animation = props.hasAnimation ? 'will-animate' : '';
	let prodCards = cards.map((card, indx) => {
		return (
			<Suspense fallback={<></>} key={indx}>
				<LoadableBuyCard
					handleProdCompare={props.handleProdCompare}
					handleQtyMinus={props.handleQtyMinus}
					handleQtyChange={props.handleQtyChange}
					handleRemoveErrorMsg={props.handleRemoveErrorMsg}
					handleQtyPlus={props.handleQtyPlus}
					handleAddToCart={props.handleAddToCart}
					handlePriceChange={props.handlePriceChange}
					hasComparisonData={props.hasComparisonData}
				currSecKey={props.currSecKey}
					key={indx}
					product={card}
					price={false}
					kind={'grouped'}
				formattedLocale={props.formattedLocale}
				currency={props.currency}
				/>
			</Suspense>
		);
	});

	return <div className={`prc__multi-pricing-cards column-22 card ${no_Animation}`}>{prodCards}</div>;
}

export default ProductGrouping;
